<template>
  <div class="mb-film">
    <img class="mb-film-bcg" v-if="filmBcg != ''" :src="filmBcg" />
    <div class="video">
      <video width="1280" height="720" id="mb-player-video" controls crossorigin playsinline>
        <source :src="giveMeImagePlease(filmSrc)" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div class="video-title">
        <span v-html="filmTitle"></span>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';

import Plyr from 'plyr';
import 'plyr/dist/plyr.css';

export default {
  props: {
    filmTitle: {
      type: String,
      default: '',
    },
    filmSrc: {
      type: String,
      default: '',
    },
    filmBcg: {
      type: String,
      default: '',
    },
  },
  name: 'mb-film',
  data: function () {
    return {
      publicPath: process.env.BASE_URL,
    };
  },

  mounted() {
    this.init();
  },
  methods: {
    init() {
      const player = new Plyr(document.getElementById('mb-player-video'));
    },
    giveMeImagePlease(path) {
      try {
        return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
      } catch (err) {
        console.log(err);
      }
    },
    getPoster() {
      let poster;
      if (this.film.item.poster) {
        poster = require(`__staticDir/${this.$store.getters.multibookType}/${this.film.item.poster}`);
      } else {
        let posterSrc = `films/base.png`;
        poster = require(`__staticDir/${this.$store.getters.multibookType}/${posterSrc}`);
      }
      return poster;
    },
    changeFilm(_name) {
      let name = _name;
      if (!name) {
        name = _.sample(VIDEO_NAMES);
      }
      return getVideoURL(name).then((videURL) => {
        this.videoFile = videURL;
        this.forceRerender();
      });
    },
    forceRerender() {
      this.componentKey = !this.componentKey;
    },
  },
};
</script>

<style lang="sass">
.mb-film
  position: absolute
  pointer-events: auto
  display: flex
  justify-content: center
  align-items: center
  width: 100%
  height: 100%
  .mb-film-bcg
    position: absolute
    width: 100vw
    height: 100vh
    top: 0
    left: 0
  .video
    display: flex
    flex-direction: column
    .video-title
      padding-top: 1vmin
      padding-bottom: 1vmin
      font-size: 3vmin
      z-index: 17

#magic-button
  pointer-events: auto
  // position: absolute;
  // opacity: 1;
  // z-index: 1003;
</style>
